<template>
  <header id="header" class="header-bg">
    <div class="header-content">
      <div class="logo-container">
        <img src="@/assets/image/logo.png" />
        <h2>AntTV</h2>
      </div>
      <nav>
        <a href="#">Home</a>
        <a href="#features">Features</a>
        <a href="#download">Download</a>
        <a href="#contact">Contact Us</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderCom',
}
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
}
.header-bg {
  .header-content {
    width: calc(100% - 60px);
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    padding: 8px 30px;
    justify-content: space-between;
    .logo-container {
      display: flex;
      align-items: center;
      img {
        width: 48px;
        height: 48px;
      }
      h2 {
        color: #fff;
        font-size: 24px;
        font-weight: bold;
      }
    }
    nav {
      margin-left: 165px;
      display: flex;
      align-items: center;
      a {
        margin-right: 32px;
        color: #fff;
        font-size: 20px;
        font-family: Inter;
        text-decoration: none;
        @media screen and (max-width: 768px) {
          font-size: 14px !important;
        }
      }
    }
  }
}
</style>
